export class ApplicationHistoryConstants {
    static HEADER = "Recent history";
    static STEP_TITLE = "History";
}
